import { FunctionComponent } from "react";

import { ThemeContext } from "../contexts/ThemeContext";
import { Theme } from "../utils/createTheme";

export const ThemeProvider: FunctionComponent<{ theme: Theme }> = ({
  theme,
  children,
}) => {
  return (
    <ThemeContext.Provider value={{ theme }}>{children}</ThemeContext.Provider>
  );
};
